import React from "react";
import "./Services.css";

// 🔹 Example: existing components
import ServiceOffer from "../components/ServiceOffer";
import Product from "../components/Product";

// 🔹 Import new sections
import TonerCartridges from "../components/TonerCartridges";
import GlobalSupply from "../components/GlobalSupply";
import WhyChooseRecla from "../components/WhyChooseRecla";
import NeedAbout from "../components/NeedAbout";
import SmarterMove from "../components/SmarterMove";

const Service = () => {
  return (
    <section className="service-page">
      {/* ====== Header Section ====== */}
      <div className="service-header">
        <h2 className="service-title">What We Offer</h2>
      </div>

    
      <Product />

      {/* ====== Recla Components ====== */}
      <div className="ps-wrapper">
        <TonerCartridges />
        
        <GlobalSupply />
         <WhyChooseRecla />
        
        <ServiceOffer />
   <NeedAbout />
          
      </div>
    </section>
  );
};

export default Service;
